__turbopack_context__.v({
  "active": "contentSamplingPlayer-module-scss-module__ArytBW__active",
  "audioContainer": "contentSamplingPlayer-module-scss-module__ArytBW__audioContainer",
  "closeButton": "contentSamplingPlayer-module-scss-module__ArytBW__closeButton",
  "controls": "contentSamplingPlayer-module-scss-module__ArytBW__controls",
  "controlsWrapperStyles": "contentSamplingPlayer-module-scss-module__ArytBW__controlsWrapperStyles",
  "lightProgressBarWrapper": "contentSamplingPlayer-module-scss-module__ArytBW__lightProgressBarWrapper",
  "lightThemePlayerControls": "contentSamplingPlayer-module-scss-module__ArytBW__lightThemePlayerControls",
  "pauseButton": "contentSamplingPlayer-module-scss-module__ArytBW__pauseButton",
  "playButton": "contentSamplingPlayer-module-scss-module__ArytBW__playButton",
  "progressBar": "contentSamplingPlayer-module-scss-module__ArytBW__progressBar",
  "progressBarWrapper": "contentSamplingPlayer-module-scss-module__ArytBW__progressBarWrapper",
  "replayButton": "contentSamplingPlayer-module-scss-module__ArytBW__replayButton",
  "slideAnimation": "contentSamplingPlayer-module-scss-module__ArytBW__slideAnimation",
  "slideInRight": "contentSamplingPlayer-module-scss-module__ArytBW__slideInRight",
  "timeDisplayWrapper": "contentSamplingPlayer-module-scss-module__ArytBW__timeDisplayWrapper",
  "timeEllapsed": "contentSamplingPlayer-module-scss-module__ArytBW__timeEllapsed",
  "timeRemaining": "contentSamplingPlayer-module-scss-module__ArytBW__timeRemaining",
  "transcriptIcon": "contentSamplingPlayer-module-scss-module__ArytBW__transcriptIcon",
});
